'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('documentsUnderReview', function(documentService) {
  return {
    restrict: 'E',
    controller: 'DocumentsCtrl as docCtrl',
    templateUrl: 'scripts/directives/documents-under-review/documents-under-review.prt.html',
    link: function() {
      documentService.getUploadDocumentsCount();
    }
  };
});
